import React from 'react';
import {
  DialogContent,
  DialogActions,
  Button,
} from '@mui/material';
import Dialog from '../atoms/Dialog';
import { LoadingButton } from '../atoms/Base';

export default function DeleteDialog(props) {
  const {
    procName,
    onDelete,
    open,
    onClose,
  } = props;

  return (
    <Dialog isOpen={open} onClose={onClose} title={`選択した${procName}の削除`} isError>
      <DialogContent dividers>{`選択した${procName}を削除します。よろしいですか？`}</DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">キャンセル</Button>
        <LoadingButton
          onClick={onDelete}
          color="secondary"
        >
          削除する
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
